import React, { useState } from "react";
import { ErrorMessage } from "formik";
import { Radio, FieldWrapper } from "./fields";
import { normalizeField } from "../inc/functions";
import errorMessages from "../inc/errorMessages";
import * as Yup from "yup";

export const LegalEntityTypeSchema = Yup.object().shape({
	type: Yup.string().required(errorMessages.required),
	entityName: Yup.string().when("type", {
		is: "Rechtspersoon",
		then: Yup.string().required(errorMessages.required),
	}),
	btwNumber: Yup.string().when("type", {
		is: "Rechtspersoon",
		then: Yup.string().required(errorMessages.required),
	}),
});

export default ({ group = "", heading="Hoedanigheid" }) => {
	const [entityType, setEntityType] = useState(0);

	const fields = [
		{
			name: "entityName",
			label: "Naam van de rechtspersoon",
			required: true,
		},
		{
			name: "btwNumber",
			label: "Ondernemingsnummer",
			text: "BTW nummer, voorafgegaan door de landcode, bijvoorbeeld BE",
			required: true,
		},
	].map(normalizeField);

	return (
		<>
			<label htmlFor={`${group}type.0`} className="mb-3">
				{heading}
			</label>

			<div className="mb-3">
				{["Rechtspersoon", "Natuurlijk persoon"].map((field, index) => (
					<Radio
						name={`${group}type`}
						id={`${group}type.${index}`}
						key={`${group}type.${index}`}
						value={field}
						label={field}
						required={true}
						onClick={(e) => {
							setEntityType(e.target.value);
						}}
					/>
				))}
			</div>

			<ErrorMessage name={`${group}type`}>
				{(msg) => <div className="invalid-feedback d-block">{msg}</div>}
			</ErrorMessage>

			{entityType === "Rechtspersoon" &&
				fields.map((field, index) => (
					<FieldWrapper
						key={`${group}entityTypeFields${index}`}
						label={field.label}
						name={`${group}${field.name}`}
						text={field.text}
						required={true}
					/>
				))}
		</>
	);
};
